import React from 'react';

interface ResponsiveHideProps {
  children: React.ReactNode;
}

const ResponsiveHide: React.FC<ResponsiveHideProps> = ({ children }) => {
  return <div className="hidden md:block">{children}</div>;
};

export default ResponsiveHide;
